exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    display: flex;\r\n    flex: 1;\r\n    flex-direction: column;\r\n    overflow: auto;\r\n}\r\n\r\n.filter-form {\r\n    margin-top: 20px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.label-col-1 {\r\n    flex: 0 0 60px;\r\n    min-width: 60px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n    margin-bottom: 3px;\r\n    line-height: 18px;\r\n}\r\n\r\n.fixed-box-1 {\r\n    min-width: 100px;\r\n    max-width: 100px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/app/stock/stock-inventory/stock-inventory.component.css
// module id = 2475
// module chunks = 1